import { useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import providerService from '../services/providerService';
import professionalsFetchedAction from '../actions/professionalsFetchedAction';

const useProfessionalsList = ({ enabled = true } = {}) => {
  const currentProvider = providerService.getCurrentProvider();
  const dispatch = useDispatch();
  const professionalsFetchedFlag = useSelector(
    (state) => state.professionalsFetched,
  );

  const fetchProfessionalsList = useCallback(async () => {
    try {
      dispatch(professionalsFetchedAction('FETCHING'));
      const professionalList =
        await providerService.getProfessionalList(currentProvider.id);
      if (professionalList) {
        dispatch(professionalsFetchedAction('FETCHED'));
      } else {
        dispatch(professionalsFetchedAction('NOFETCH'));
      }
      return professionalList;
    } catch (error) {
      dispatch(professionalsFetchedAction('NONE'));
      console.error('Failed to fetch professionals:', error);
      return null;
    }
  }, [dispatch, currentProvider.id]);

  useEffect(() => {
    if (!enabled) return;
    if (professionalsFetchedFlag === 'NONE') {
      fetchProfessionalsList();
    }
  }, [enabled, professionalsFetchedFlag, fetchProfessionalsList]);
};

export default useProfessionalsList;
